import { SESSION_EXPIRED_PATH } from '@healthhub/message-channel';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import type { RouteConfig } from '@shared/types/common.types';

const SessionExpiryPage = lazy(() => import('./pages/SessionExpiryPage/SessionExpiryPage'));

export const SYSTEM_ROUTES: RouteConfig[] = [
  {
    // Only used by portal, mobile detect path to redirect to mobile pre-login page
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SessionExpiryPage />,
    displayTitle: () => 'Session Expired',
    pageType: PageType.PUBLIC,
    path: SESSION_EXPIRED_PATH,
    serviceCatalogCode: '',
  },
];
